<template lang="pug">
  el-card.filter-panel(
    shadow="never"
  )
    .filter-panel__input
      el-select(
        :value="vendorId"
        filterable
        :placeholder="$t('请选择供应商')"
        style="width:168px"
        @change="handleChangeVendor"
      )
        el-option(
          v-for="(item,index) in vendorOptions"
          :key="index"
          :label="item.struct_group_name"
          :value="item.struct_group_id"
        )
    .filter-panel__input
      el-select(
        :value="brandId"
        filterable
        :placeholder="$t('请选择品牌')"
        style="width:168px"
        @change="handleChangeBrand"
      )
        el-option(
          v-for="(item,index) in brandOptions"
          :key="index"
          :label="item.brand_name"
          :value="item.brand_id"
        )
    .filter-panel__cancel
      span(@click="cancel") {{ $t("清空") }}
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      vendorOptions: [],
      brandOptions: []
    }
  },
  mounted () {
    this.getVendorList()
    this.getBrandList()
  },
  computed: {
    vendorId () {
      return this.$store.state.campaign.campaignListVendorId
    },
    brandId () {
      return this.$store.state.campaign.campaignListBrandId
    }
  },
  methods: {
    getVendorList () {
      axios.get('/admin/struct/getAllRegisterCompletedVendorList').then(res => {
        this.vendorOptions = res
      })
    },
    getBrandList () {
      axios.get('/common/getBrandList').then(res => {
        this.brandOptions = res
      })
    },
    cancel () {
      this.$emit('clear')
    },
    handleChangeVendor (val) {
      this.$emit('changeVendor', val)
    },
    handleChangeBrand (val) {
      this.$emit('changeBrand', val)
    }
  }
}
</script>

<style lang="stylus">
.filter-panel
  display flex
  margin 17px 0 0
  .el-card__body
    justify-content flex-end
    width 100%
    display flex
    align-items center
    .filter-panel__input
      &:nth-child(1)
        margin-right 24px
      &:nth-child(2)
        margin-right: 30px
    .el-select-dropdown
        width 300px !important
        max-width 300px
    .filter-panel__cancel
      color $main
      cursor pointer
</style>
